module.exports = {
  PREFETCHED: 'prefetched',
  CREATED: 'created',
  STARTED: 'started',
  READY: 'ready',
  CONFIRMED_BALANCE_CHANGED: 'confirmed_balance_changed',
  UNCONFIRMED_BALANCE_CHANGED: 'unconfirmed_balance_changed',
  BLOCKHEIGHT_CHANGED: 'blockheight_changed',
  BLOCK: 'block',
  TRANSACTION: 'transaction',
  BLOCKHEADER: 'blockheader',
  FETCHED_ADDRESS: 'FETCHED/ADDRESS',
  ERROR_UPDATE_ADDRESS: 'ERROR/UPDATE_ADDRESS',
  FETCHED_TRANSACTION: 'FETCHED/TRANSACTION',
  FETCHED_UNCONFIRMED_TRANSACTION: 'FETCHED/UNCONFIRMED_TRANSACTION',
  FETCHED_CONFIRMED_TRANSACTION: 'FETCHED/CONFIRMED_TRANSACTION',
  CONFIRMED_TRANSACTION: 'CONFIRMED_TRANSACTION',
  GENERATED_ADDRESS: 'GENERATED_ADDRESS',
  DISCOVERY_STARTED: 'DISCOVERY_STARTED',
  CONFIGURED: 'CONFIGURED',
  INITIALIZED: 'INITIALIZED',
  SAVE_STATE_FAILED: 'SAVE_STATE_FAILED',
  SAVE_STATE_SUCCESS: 'SAVE_STATE_SUCCESS',
  REHYDRATE_STATE_FAILED: 'REHYDRATE_STATE_FAILED',
  REHYDRATE_STATE_SUCCESS: 'REHYDRATE_STATE_SUCCESS',
  INSTANT_LOCK: 'INSTANT_LOCK',
  TX_METADATA: 'TX_METADATA',
  HEADERS_SYNC_PROGRESS: 'HEADERS_SYNC_PROGRESS',
  TRANSACTIONS_SYNC_PROGRESS: 'TRANSACTIONS_SYNC_PROGRESS',
};
